export const leftPad = p => n => (n + '').length >= p ? n + '' : Array(p - (n + '').length + 1).join('0') + n;

export const calculateTime = s => `${Math.floor(s / 60)}:${leftPad(2)(s % 60)}`;